
export default {//改变state里定义的变量的方法,调用方法是this.$store.commit('方法名','要改变的数据')
    setUserInfo (state, obj) {
        state.userInfo = obj;
    },
    setIsLogin (state, boolean) {
        state.isLogin = boolean;
    },
    setShowLogin (state, boolean) {
        state.show_login_compoments = boolean;
    },
    setShowUserInfo (state, boolean) {
        state.show_userinfo_compoments = boolean;
    },
    setShowCodeExchange (state, boolean) {
        state.show_code_exchange_compoments = boolean;
    },
    setShowBindPhone (state, boolean) {
        state.show_bindphone_compoments = boolean;
    },
    setShowAttenDance (state, boolean) {
        state.show_attendance_compoments = boolean;
    },
    setShowOpen (state, boolean) {
        state.show_open_compoments = boolean;
    },
    setShowQuestion (state, boolean) {
        state.show_question_compoments = boolean;
    },
    setToastVip (state, boolean) {
        state.show_toast_vip = boolean;
    },
    setVideoType (state, type) {
        state.video_type = type;
    },
    setInviteCode (state, boolean) {
        state.shou_invite_code = boolean;
    },
    videoPlayUrl(state,data){
        state.video_play_url = data
    },
    showVideoPop(state,data){
        state.show_video_pop = data
    },
    showVipTime(state,data){
        state.show_vip_time = data
    },
    kekePopSet(state,data){
        state.kekePop = data
    },
    setisInputValshow (state, obj) {
        state.isInputValshow = obj;
    },
    setisInputtype (state, obj) {
        state.isInputtype = obj;
    },
    setisInputVal (state, obj) {
        state.isInputVal = obj;
    },
    setIsYouhuiPopshow(state, data){
        state.isYouhuiPopshow = data
    },
    set_type(state,data){
        state._type = data
    },
    setYouhuiPayDeail(state, data){
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                state.youhuiPayDeail[key] = data[key]
                }
        }
        console.log(state.youhuiPayDeail);
    },
    setNewPayPop(state, data){
        state.newPayPop = data
    },
    setcomVipShow(state,data){
        state.comVipShow = data
    },
    /* 新版支付相关 */
    setFisYouh(state, boolean){
        state.fisYouh = boolean;
    },
    setSecYouh(state, boolean){
        state.secYouh = boolean;
    },
    setHeader_r_show(state, data) {
        state.header_r_show = data;
    },
    setVipYouhuiHeaderShow(state, data) {
		state.vip_youhui_header_show = data;
	},
    //恭喜你成为xxx弹窗
    setVipCongratulationsShow(state, data) {
		state.vip_congratulations_show = data;
	},
    //sora模型 1:Sora2 2:Sora
    setSoraModel(state, data) {
		state.sora_model = data;
	},
    //opt技术弹窗
    setIsOPTshow(state, data) {
		state.isOPTshow = data;
	},
}
